// 모달 범용 훅

import { useState } from 'react'

export const useModal = () => {
  // const [isOpen, setIsOpen] = useState(false)
  const [modalType, setModalType] = useState(null);
  const open = (type) => setModalType(type);
  const close = () => setModalType(null);
  const isOpen = modalType !== null;

  return {open, close, modalType, isOpen};
}
